import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import courseReducer from '../features/courses/coursesSlice';
import profileReducer from '../features/profile/profileSlice';
import searchReducer from '../features/search/searchSlice';
import studentsReducer from '../features/students/studentsSlice';
import workspacesReducer from '../features/workspaces/workspacesSlice';
import assignmentsReducer from '../features/assignments/assignmentsSlice';
import accountReducer from '../features/account/accountSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import lookupsReducer from '../features/lookups/lookupsSlice';

export const store = configureStore({
  reducer: {
    course: courseReducer,
    search: searchReducer,
    profile: profileReducer,
    students: studentsReducer,
    workspaces: workspacesReducer,
    assignments: assignmentsReducer,
    account: accountReducer,
    notifications: notificationsReducer,
    lookups: lookupsReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;

// Typed dispatch hook — accepts thunks (so callers can `.unwrap()`).
export const useAppDispatch: () => AppDispatch = useDispatch;
